/**
 * File Name          : console-capture.service.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-26
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsoleCaptureService {
  private logs: string[] = [];

  constructor() {
    this.patchConsole();

    window.addEventListener('error', (e) => {
      this.logs.push(`[WINDOW ERROR] ${e.message}`);
    });

    window.addEventListener('unhandledrejection', (e) => {
      this.logs.push(`[PROMISE ERROR] ${e.reason}`);
    });
  }

  private patchConsole() {
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;

    console.log = (...args: any[]) => {
      this.logs.push(`[LOG] ${this.stringify(args)}`);
      originalLog.apply(console, args);
    };

    console.error = (...args: any[]) => {
      this.logs.push(`[ERROR] ${this.stringify(args)}`);
      originalError.apply(console, args);
    };

    console.warn = (...args: any[]) => {
      this.logs.push(`[WARN] ${this.stringify(args)}`);
      originalWarn.apply(console, args);
    };
  }

  public log(...args: any[]) {
    this.logs.push(`[LOG] ${this.stringify(args)}`);
  }

  public error(...args: any[]) {
    this.logs.push(`[ERROR] ${this.stringify(args)}`);
  }

  public warn(...args: any[]) {
    this.logs.push(`[WARN] ${this.stringify(args)}`);
  }

  

  private stringify(args: any[]) {
    return args.map(a => {
      if (a instanceof Error) {
        return `${a.name}: ${a.message}\n${a.stack}`;
      }
      return typeof a === 'object'
        ? JSON.stringify(a, null, 2)
        : a;
    }).join(' ');
  }

  downloadLogs() {
    const blob = new Blob([this.logs.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'console-log.txt';
    a.click();

    URL.revokeObjectURL(url);
  }
}
